module.exports = __webpack_public_path__ + "img/gastosViaje.3bbabd60.png";